const ELEMENT_COLOR = {
  Wood: "#7FD4A0", Fire: "#F26D6D", Earth: "#D4AF37", Metal: "#C9D1D9", Water: "#45F0DF",
};

const PILLARS = [
  ["hour", "Hour"], ["day", "Day"], ["month", "Month"], ["year", "Year"],
];

export function BaziTable({ chinese, compact = false }) {
  const { pillars } = chinese;
  return (
    <div className="w-full">
      <table className="w-full border-collapse text-center" data-testid="bazi-table">
        <thead>
          <tr>
            <th className="p-2 text-[10px] uppercase tracking-wider text-white/40 font-medium text-left">Pillar</th>
            {PILLARS.map(([k, label]) => (
              <th key={k} className="p-2 text-[11px] uppercase tracking-wider text-white/50 font-medium">{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-white/10">
            <td className="p-2 text-[10px] uppercase tracking-wider text-white/40 text-left">Heavenly Stem</td>
            {PILLARS.map(([k]) => (
              <td key={k} className="p-2">
                <span className="text-sm font-medium" style={{ color: ELEMENT_COLOR[pillars[k].element] }}>
                  {pillars[k].stem}
                </span>
                <div className="text-[9px] text-white/40">{pillars[k].element}</div>
              </td>
            ))}
          </tr>
          <tr className="border-t border-white/10">
            <td className="p-2 text-[10px] uppercase tracking-wider text-white/40 text-left">Earthly Branch</td>
            {PILLARS.map(([k]) => (
              <td key={k} className="p-2">
                <span className="text-sm gold-text">{pillars[k].branch}</span>
                <div className="text-[9px] text-white/40">{pillars[k].animal}</div>
              </td>
            ))}
          </tr>
          {!compact && (
            <tr className="border-t border-white/10">
              <td className="p-2 text-[10px] uppercase tracking-wider text-white/40 text-left">Polarity</td>
              {PILLARS.map(([k]) => (
                <td key={k} className="p-2 text-xs text-white/60">{pillars[k].polarity}</td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-[10px] uppercase tracking-wider text-white/40">Day Master:</span>
        <span className="rounded-full border border-white/10 px-3 py-1 text-xs" style={{ color: ELEMENT_COLOR[chinese.day_master.element] }}>
          {chinese.day_master.polarity} {chinese.day_master.element}
        </span>
        {Object.entries(chinese.element_balance).map(([el, n]) => (
          <span key={el} className="rounded-full border border-white/10 px-3 py-1 text-xs text-white/70">{el} · {n}</span>
        ))}
      </div>
    </div>
  );
}
